/*
 * @Description: 编辑和确定
 * @Author: yy
 * @LastEditors: yy
 * @Date: 2019-04-18 10:23:01
 * @LastEditTime: 2019-04-24 10:44:39
 */
import React, {Component} from 'react'
import withStyles from 'isomorphic-style-loader/lib/withStyles';
// @ts-ignore
import s from './style.css'

class EditInput extends Component {
  constructor (props) {
    super(props)

    this.state = {
      inputValue: ''
    }

    this.inputChange = this.inputChange.bind(this)
    this.clickHandle = this.clickHandle.bind(this)
  }

  /**
   * inputValue修改事件
   * @param {*} e 
   */
  inputChange (e) {
    this.setState({
      inputValue: e.target.value
    })
  }

  /**
   * 点击按钮事件，调用父组件传入方法
   */
  clickHandle () {
    const onClick = this.props.onClick || null
    typeof onClick === 'function' && onClick(this.state.inputValue)

    this.setState({
      inputValue: ''
    })
  }

  render () {
    const inputValue = this.state.inputValue
    return (
      <div className={s.editWrapper}>
        <input className={s.input} value={inputValue} placeholder={this.props.placeholder || ''} onChange={this.inputChange} type="text"/>
        <button type="button" className={`${s.btn} ${s.danger}`} onClick={this.clickHandle}>确认添加</button>
      </div>
    )
  }
}

export default withStyles(s)(EditInput)


// WEBPACK FOOTER //
// src/routes/cms/EditInput.js